import {css} from '@emotion/react';
import styled from '@emotion/styled';

type SeasonalBackgroundProps = {
  bannerBackgroundLarge?: string;
  bannerBackgroundLargePosition: string;
  bannerBackgroundLargeSize: string;
  bannerBackgroundSmall?: string;
  bannerBackgroundSmallPosition: string;
  bannerBackgroundSmallSize: string;
};

export const SeasonalBackground = styled.div<SeasonalBackgroundProps>(
  ({
    theme,
    bannerBackgroundLarge,
    bannerBackgroundLargePosition,
    bannerBackgroundLargeSize,
    bannerBackgroundSmall,
    bannerBackgroundSmallPosition,
    bannerBackgroundSmallSize,
  }) => {
    const smallBackgroundSize =
      bannerBackgroundSmallSize === '100% 100%' &&
      bannerBackgroundSmallPosition !== 'center center'
        ? 'auto 100%'
        : bannerBackgroundSmallSize;

    const largeBackgroundSize =
      bannerBackgroundLargeSize === '100% 100%' &&
      bannerBackgroundLargePosition !== 'center center'
        ? '100% auto'
        : bannerBackgroundLargeSize;

    return css`
      position: absolute;
      inset: 0;
      background-repeat: no-repeat;

      ${bannerBackgroundSmall &&
      css`
        background-image: ${`url(${bannerBackgroundSmall})`};
        background-size: ${smallBackgroundSize};
        background-position: ${bannerBackgroundSmallPosition};
      `}

      ${bannerBackgroundLarge &&
      theme.respondTo(
        'md',
        css`
          background-image: ${`url(${bannerBackgroundLarge})`};
          background-size: ${largeBackgroundSize};
          background-position: ${bannerBackgroundLargePosition};
        `
      )}
    `;
  }
);
